import * as React from "react";
import {LegacyRef} from "react";
import { useZxing } from "react-zxing";
import "./CodeScanner.css"

interface Props {
  successHandler: (result: string) => void
}

function CodeScanner(props: Props) {
  const { ref } = useZxing({
    onDecodeResult(result) {
      props.successHandler(result.getText())
    },
  });

  return (
      <>
        <div className={"code-scanner"}>
          <div className={""}>
            <video className={"border-radius"} width={"324px"} ref={ref as unknown as LegacyRef<HTMLVideoElement>} />
          </div>
        </div>
      </>
  );
}

export default CodeScanner;